import { cn } from "@/ui/cn";

export function FormSection({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return (
    <div
      data-slot="form-section"
      className={cn("pl-4 border-l border-border space-y-4", className)}
    >
      {children}
    </div>
  );
}
